import React from "react";
export default () => (
  <svg
    width="100%"
    height="20"
    viewBox="0 0 712 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0)">
      <path
        opacity="0.4"
        d="M676 8H680V12H676V8ZM684 8H712V12H684V8ZM676 16H680V20H676V16ZM684 16H706V20H684V16ZM676 24H680V28H676V24ZM684 24H712V28H684V24Z"
        fill="black"
      />
      <g opacity="0.4">
        <path
          opacity="0.4"
          d="M627 26C621 26 616 21 616 15C616 9 621 4 627 4C633 4 638 9 638 15C638 21 633 26 627 26ZM627 7C622.6 7 619 10.6 619 15C619 19.4 622.6 23 627 23C631.4 23 635 19.4 635 15C635 10.6 631.4 7 627 7Z"
          fill="black"
        />
        <path
          opacity="0.4"
          d="M643 32.4001C642.6 32.4001 642.2 32.2001 642 32.0001L633 23.0001C632.4 22.4001 632.4 21.4001 633 20.8001C633.6 20.2001 634.6 20.2001 635.2 20.8001L644 30.0001C644.6 30.6001 644.6 31.6001 644 32.2001C643.8 32.4001 643.4 32.4001 643 32.4001Z"
          fill="black"
        />
      </g>
      <g opacity="0.4">
        <path
          opacity="0.4"
          d="M418.4 28.0002V8.2002H430.8V11.0002H421.6V17.0002H430V19.8002H421.6V28.0002H418.4Z"
          fill="black"
        />
        <path
          opacity="0.4"
          d="M434.2 13.1998H437V15.3998H437.2C437.6 13.9998 439.2 12.7998 441.2 12.7998C441.6 12.7998 442.2 12.7998 442.6 12.9998V15.7998C442.4 15.7998 441.4 15.5998 441 15.5998C438.8 15.5998 437.2 16.9998 437.2 19.1998V27.9998H434.2V13.1998Z"
          fill="black"
        />
        <path
          opacity="0.4"
          d="M444.6 8.8C444.6 7.8 445.4 7 446.4 7C447.4 7 448.4 7.8 448.4 8.8C448.4 9.8 447.6 10.6 446.4 10.6C445.2 10.6 444.6 9.8 444.6 8.8V8.8ZM445 13.2H448V28H445V13.2Z"
          fill="black"
        />
        <path
          opacity="0.4"
          d="M464 11.6002H463.8L458.8 15.2002V12.0002L464 8.2002H467V28.0002H464V11.6002Z"
          fill="black"
        />
        <path
          opacity="0.4"
          d="M477.2 11.5999H477L472 15.1999V11.9999L477.2 8.3999H480.2V27.9999H477.2V11.5999Z"
          fill="black"
        />
        <path
          opacity="0.4"
          d="M486 15.7998C486 14.5998 486.8 13.7998 488 13.7998C489.2 13.7998 490 14.5998 490 15.7998C490 16.9998 489.2 17.7998 488 17.7998C487 17.9998 486 16.9998 486 15.7998ZM486 26.1998C486 24.9998 486.8 24.1998 488 24.1998C489.2 24.1998 490 24.9998 490 26.1998C490 27.3998 489.2 28.1998 488 28.1998C487 28.1998 486 27.3998 486 26.1998Z"
          fill="black"
        />
        <path
          opacity="0.4"
          d="M500.8 7.7998C504.6 7.7998 507.4 10.1998 507.4 13.3998C507.4 15.3998 506.4 17.1998 503 20.5998L498.6 24.9998V25.1998H507.6V27.9998H494.4V25.7998L501 18.7998C503.6 15.9998 504.2 14.9998 504.2 13.5998C504.2 11.7998 502.6 10.3998 500.6 10.3998C498.4 10.3998 497 11.7998 497 13.9998H494.2C494.2 10.3998 497 7.7998 500.8 7.7998V7.7998Z"
          fill="black"
        />
        <path
          opacity="0.4"
          d="M517.8 7.7998C521.6 7.7998 524.4 10.1998 524.4 13.3998C524.4 15.3998 523.4 17.1998 520 20.5998L515.6 24.9998V25.1998H524.6V27.9998H511.4V25.7998L518 18.7998C520.6 15.9998 521.2 14.9998 521.2 13.5998C521.2 11.7998 519.6 10.3998 517.6 10.3998C515.4 10.3998 514 11.7998 514 13.9998H511.2C511.2 10.3998 514 7.7998 517.8 7.7998V7.7998Z"
          fill="black"
        />
        <path
          opacity="0.4"
          d="M547 22.8002H539.4L537.8 28.0002H534.6L541.8 8.2002H545L552.2 28.0002H549L547 22.8002ZM540.4 20.2002H546.4L543.6 11.8002H543.4L540.4 20.2002Z"
          fill="black"
        />
        <path
          opacity="0.4"
          d="M572.4 28.0002V13.8002H572.2L566.4 27.4002H564L558.2 13.8002H558V28.0002H555.2V8.2002H558.8L565 23.2002H565.2L571.4 8.2002H575V28.0002H572.4Z"
          fill="black"
        />
      </g>
      <g opacity="0.4">
        <path
          opacity="0.4"
          d="M118 14C118 13 118.8 12 120 12H126L134 6V30L126 24H120C119 24 118 23 118 22V14Z"
          fill="black"
        />
        <path
          opacity="0.4"
          d="M147.6 29.0001C147.4 29.0001 147.2 29.0001 147 28.8001C146.6 28.4001 146.6 27.8001 147 27.4001C149.4 24.8001 150.8 21.4001 150.8 17.6001C150.8 13.8001 149.4 10.4001 146.8 7.8001C146.4 7.4001 146.4 6.8001 146.8 6.4001C147.2 6.0001 147.8 6.0001 148.2 6.4001C151 9.4001 152.6 13.4001 152.6 17.6001C152.6 21.8001 151 25.8001 148.2 28.8001C148.2 28.8001 147.8 29.0001 147.6 29.0001V29.0001Z"
          fill="black"
        />
        <path
          opacity="0.4"
          d="M139.8 25.9999C139.6 25.9999 139.2 25.7999 139 25.5999C138.6 25.1999 138.6 24.5999 139 24.1999C140.8 22.5999 141.6 20.1999 141.6 17.7999C141.6 15.3999 140.6 13.1999 139 11.5999C138.6 11.1999 138.6 10.5999 139 10.1999C139.4 9.7999 140 9.7999 140.4 10.1999C142.4 12.1999 143.6 14.9999 143.6 17.7999C143.6 20.7999 142.4 23.5999 140.2 25.5999C140.4 25.9999 140 25.9999 139.8 25.9999Z"
          fill="black"
        />
      </g>
      <g opacity="0.4">
        <g opacity="0.4">
          <path
            opacity="0.4"
            d="M292 23C294.2 23 296 20.8 296 18C296 15.2 294.2 13 292 13"
            fill="black"
          />
          <g opacity="0.4">
            <path
              opacity="0.4"
              d="M185.8 12L181.4 15V12.2L185.8 9H188.4V26H185.8V12Z"
              fill="black"
            />
            <path
              opacity="0.4"
              d="M193.2 17.6003C193.2 12.0003 195.6 8.80029 199.4 8.80029C203.4 8.80029 205.6 12.0003 205.6 17.6003C205.6 23.2003 203.4 26.4003 199.4 26.4003C195.4 26.4003 193.2 23.2003 193.2 17.6003V17.6003ZM203 17.6003C203 13.4003 201.6 11.0003 199.4 11.0003C197.2 11.0003 195.8 13.2003 195.8 17.6003C195.8 21.8003 197.2 24.2003 199.4 24.2003C201.6 24.2003 203 21.8003 203 17.6003Z"
              fill="black"
            />
            <path
              opacity="0.4"
              d="M208.8 17.6003C208.8 12.0003 211.2 8.80029 215 8.80029C219 8.80029 221.2 12.0003 221.2 17.6003C221.2 23.2003 219 26.4003 215 26.4003C211 26.4003 208.8 23.2003 208.8 17.6003V17.6003ZM218.6 17.6003C218.6 13.4003 217.2 11.0003 215 11.0003C212.8 11.0003 211.4 13.4003 211.4 17.6003C211.4 21.8003 212.8 24.2003 215 24.2003C217.2 24.2003 218.6 21.8003 218.6 17.6003Z"
              fill="black"
            />
            <path
              opacity="0.4"
              d="M227.4 17.0001C225.2 17.0001 223.6 15.2001 223.6 12.8001C223.6 10.4001 225.2 8.6001 227.4 8.6001C229.6 8.6001 231.2 10.2001 231.2 12.8001C231 15.4001 229.6 17.0001 227.4 17.0001ZM225.2 26.0001L231.6 17.2001L237.2 9.2001H239.8L233.2 18.0001L227.6 26.0001H225.2ZM229 13.0001C229 11.6001 228.4 10.6001 227.4 10.6001C226.4 10.6001 225.8 11.6001 225.8 13.0001C225.8 14.4001 226.4 15.4001 227.4 15.4001C228.4 15.4001 229 14.4001 229 13.0001ZM237.4 26.4001C235.2 26.4001 233.6 24.6001 233.6 22.2001C233.6 19.8001 235.2 18.0001 237.4 18.0001C239.6 18.0001 241.2 19.6001 241.2 22.2001C241.2 24.6001 239.6 26.4001 237.4 26.4001ZM239 22.2001C239 20.8001 238.4 19.8001 237.4 19.8001C236.4 19.8001 235.8 20.8001 235.8 22.2001C235.8 23.6001 236.4 24.6001 237.4 24.6001C238.4 24.6001 239 23.6001 239 22.2001Z"
              fill="black"
            />
          </g>
          <path
            opacity="0.4"
            d="M285 30H255C252.2 30 250 27.8 250 25V11C250 8.2 252.2 6 255 6H285C287.8 6 290 8.2 290 11V25C290 27.8 287.8 30 285 30ZM255 8C253.4 8 252 9.4 252 11V25C252 26.6 253.4 28 255 28H285C286.6 28 288 26.6 288 25V11C288 9.4 286.6 8 285 8H255Z"
            fill="black"
          />
        </g>
        <path opacity="0.4" d="M254 10H286V26H254V10Z" fill="black" />
      </g>
      <g opacity="0.4">
        <path
          opacity="0.4"
          d="M59.6 13.3998L58 11.7998L58.8 10.9998C64.2 5.7998 71.4 2.7998 79 2.7998C86.6 2.7998 93.6 5.5998 99.2 10.7998L100 11.5998L98.4 13.3998L97.6 12.5998C92.6 7.7998 86 5.1998 79.2 5.1998C72 5.1998 65.4 7.7998 60.4 12.5998L59.6 13.3998Z"
          fill="black"
        />
        <path
          opacity="0.4"
          d="M92.8001 19.1998L92.0001 18.3998C88.6001 15.1998 84.0001 13.3998 79.2001 13.3998C74.4001 13.3998 69.8001 15.1998 66.4001 18.3998L65.2001 18.9998L63.6001 17.3998L64.4001 16.5998C68.4001 12.9998 73.4001 10.7998 78.8001 10.7998C84.2001 10.7998 89.4001 12.7998 93.4001 16.5998L94.2001 17.3998L92.8001 19.1998Z"
          fill="black"
        />
        <path
          opacity="0.4"
          d="M87.1999 24.7998L86.1999 23.9998C84.1999 22.1998 81.5999 21.1998 78.9999 21.1998C76.3999 21.1998 73.7999 22.1998 71.7999 23.9998L70.9999 24.7998L69.3999 22.9998L70.1999 22.1998C72.5999 19.9998 75.7999 18.7998 78.9999 18.7998C82.1999 18.7998 85.3999 19.9998 87.7999 22.1998L88.5999 22.9998L87.1999 24.7998Z"
          fill="black"
        />
        <path
          opacity="0.4"
          d="M79 31.9996C79 31.9996 79 31.9996 83 28.9996C82 27.7996 79 27.5996 79 27.5996C79 27.5996 75.8 27.7996 75 29.1996C79 31.9996 79 31.9996 79 31.9996V31.9996Z"
          fill="black"
        />
      </g>
      <g opacity="0.4">
        <g opacity="0.4">
          <path
            opacity="0.4"
            d="M3 22C1.4 22 0 20.6 0 19C0 17.4 1.4 16 3 16C4.6 16 6 17.4 6 19C6 20.6 4.6 22 3 22ZM11 22C9.4 22 8 20.6 8 19C8 17.4 9.4 16 11 16C12.6 16 14 17.4 14 19C14 20.6 12.6 22 11 22ZM19 22C17.4 22 16 20.6 16 19C16 17.4 17.4 16 19 16C20.6 16 22 17.4 22 19C22 20.6 20.6 22 19 22Z"
            fill="black"
          />
          <path
            opacity="0.5"
            d="M11 36.4002V23.0002H13V31.6002L18.6 26.4002L14.4 22.8002L15.6 21.2002L21.4 26.4002L11 36.4002Z"
            fill="black"
          />
          <path
            opacity="0.5"
            d="M15.6 18.8001L14.4 17.2001L18.6 13.6001L13 8.4001V17.0001H11V3.6001L21.4 13.6001L15.6 18.8001Z"
            fill="black"
          />
        </g>
        <path
          opacity="0.5"
          d="M1.323 12.7373L2.7372 11.3231L8.67684 17.2627L7.26264 18.6769L1.323 12.7373Z"
          fill="black"
        />
        <path
          opacity="0.5"
          d="M1.323 27.2627L7.26264 21.3231L8.67684 22.7373L2.7372 28.6769L1.323 27.2627Z"
          fill="black"
        />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M339.06 5.99998C339.062 4.83672 339.395 3.75144 339.97 2.83303L352.897 16.4106C352.47 16.915 352.066 17.4398 351.687 17.9833C353.12 20.0566 354.916 21.8599 356.983 23.3007C357.479 22.9586 357.958 22.5956 358.421 22.2133L371.128 35.5596C370.443 35.8297 369.697 35.9774 368.916 35.9758L345 35.9282C341.686 35.9216 339.005 33.23 339.012 29.9163L339.06 5.99998ZM362.301 18.0044C361.776 18.7574 361.203 19.4743 360.587 20.1507L373.566 33.7829C374.415 32.7502 374.925 31.4288 374.928 29.9878L374.976 6.07149C374.978 4.84217 374.611 3.69848 373.978 2.74571L360.702 15.9697C361.275 16.6137 361.809 17.2932 362.301 18.0044ZM358.553 13.8761L371.745 0.735619C370.92 0.305494 369.983 0.0615341 368.988 0.0595536L345.071 0.0119395C344.006 0.00981785 343.004 0.285664 342.136 0.771134L354.988 14.2699C355.626 13.7027 356.3 13.1739 357.004 12.687C357.539 13.0597 358.056 13.4566 358.553 13.8761Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="712" height="36" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
